<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFilterOutline } from "@mdi/js";
export default {
  name: "MdiFilterOutline",
  data() {
    return {
      svgPath: mdiFilterOutline,
    };
  },
};
</script>
